import React, { useEffect } from 'react';
import './Sustainability.css';

// Import sustainability images
import sustainabilityNaturalImg from '../assets/images/sustainability/natural-products_new.jpg';
import sustainabilityEcoImg from '../assets/images/sustainability/eco-conscious_new.jpg';
import sustainabilitySourcingImg from '../assets/images/sustainability/responsible-sourcing_new.jpg';
import sustainabilityLongTermImg from '../assets/images/sustainability/long-term.jpg';
import sustainabilityBannerImg from '../assets/images/sustainability/banner.jpg';

const Sustainability = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const sustainabilitySections = [
    {
      id: 1,
      title: 'Supporting Natural Products',
      image: sustainabilityNaturalImg,
      text: 'Our focus is on natural and minimally processed products that respect traditional agricultural practices.',
      imagePosition: 'left'
    },
    {
      id: 2,
      title: 'Eco-Conscious Product Range',
      image: sustainabilityEcoImg,
      text: 'We promote eco-friendly and reusable products that support sustainable living and rural livelihoods.',
      imagePosition: 'right'
    },
    {
      id: 3,
      title: 'Responsible Sourcing',
      image: sustainabilitySourcingImg,
      text: 'We work closely with local producers and small suppliers, encouraging responsible sourcing and fair practices.',
      imagePosition: 'left'
    },
    {
      id: 4,
      title: 'Long-Term Vision',
      image: sustainabilityLongTermImg,
      text: 'As we grow, sustainability remains central to how we expand our product range and export operations.',
      imagePosition: 'right'
    }
  ];

  return (
    <div className="sustainability-page">
      {/* Top Banner */}
      <div className="sustainability-banner">
        <div 
          className="sustainability-banner-image"
          style={{ backgroundImage: `url(${sustainabilityBannerImg})` }}
        >
          <div className="sustainability-banner-overlay"></div>
          <div className="sustainability-banner-content">
            <h1 className="sustainability-banner-title">Growing with Responsibility</h1>
            <p className="sustainability-banner-subtitle">Respecting Nature at Every Step</p>
          </div>
        </div>
      </div>

      {/* Content Sections */}
      <div className="sustainability-content">
        {sustainabilitySections.map((section, index) => (
          <React.Fragment key={section.id}>
            <section className={`sustainability-section ${section.imagePosition}`}>
              <div className="sustainability-section-container">
                <div className="sustainability-section-image">
                  <img src={section.image} alt={section.title} />
                </div>
                <div className="sustainability-section-text">
                  <h2>{section.title}</h2>
                  <p>{section.text}</p>
                </div>
              </div>
            </section>
            {index < sustainabilitySections.length - 1 && (
              <div className="sustainability-separator"></div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default Sustainability;
